<template>
  <!-- 联系人 -->
  <div class="container">
    <div class="popup">
      <div class="popup_header flex mb_20">
        <!-- <el-button @click="update_link_dialog = true"
                   class="mr_80"
                   type="primary">+添加联系人</el-button> -->
        <div class="popup_search flex mr_20">
          <div class="w_220 mr_20">
            <el-input v-model="linkParams.name"
                      placeholder="请输入内容"
                      @keyup.enter.native="getLinkDataSearch()"></el-input>
          </div>
          <el-button @click="getLinkDataSearch()"
                     type="primary">搜索</el-button>
        </div>
        <el-button @click="resetLinkData"
                   type="danger">重置</el-button>
      </div>
      <div class="popup_main">
        <el-table :data="linkData"
                  border
                  style="width: 100%"
                  class="mb_20">
          <el-table-column prop="company"
                           label="公司"
                           width="180"></el-table-column>
          <el-table-column prop="addr"
                           label="地址"
                           width="180"></el-table-column>
          <el-table-column prop="email"
                           label="邮箱"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="r">
              <el-button @click="contacterSelect(r.$index,r.row)"
                         type="text">选择</el-button>
              <!-- <el-button @click="linkEditor(r.$index,r.row)"
                         type="text">编辑</el-button> -->
              <!-- <el-button @click="linkDelete(r.$index,r.row)"
                         class="color_red"
                         type="text">删除</el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="flex justify_end">
        <el-pagination @current-change="linkPageChange"
                       background
                       layout="total, prev, pager, next"
                       :total="linkTotal">
        </el-pagination>
      </div>
    </div>
    <el-form :model="updateLinkData"
             :rules="linkRules"
             ref="updateLinkData"
             label-width="140px">
      <el-dialog :title="updateLinkData.company? '编辑联系人':'添加联系人'"
                 :visible.sync="update_link_dialog"
                 append-to-body>
        <div class="update_link_popup popup w_460">
          <div class="mb_20">
            <el-button @click="return_link"
                       class="mr_80"
                       type="primary">返回</el-button>
          </div>
          <div class="popup_main">
            <div class="mb_20">
              <el-table-column
                prop="name"
                label="联系人姓名"
                width="180"
              ></el-table-column>
              <el-form-item label="公司名称"
                            prop="company">
                <el-input v-model="updateLinkData.company"></el-input>
              </el-form-item>
            </div>
            <div class="mb_20">
              <el-form-item label="公司地址"
                            prop="addr">
                <el-input v-model="updateLinkData.addr"></el-input>
              </el-form-item>
            </div>
            <div class="mb_20">
              <el-form-item label="国家"
                            prop="country">
                <el-select v-model="updateLinkData.country"
                           filterable
                           placeholder="请选择国家">
                  <el-option v-for="(link_item,lin_index) in countryData"
                             :key="lin_index"
                             :label="link_item.name"
                             :value="link_item.name">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="mb_20">
              <el-form-item label="联系人固话"
                            prop="telephone">
                <el-input v-model="updateLinkData.telephone"></el-input>
              </el-form-item>
            </div>
            <div class="mb_20">
              <el-form-item label="联系人姓名"
                            prop="name">
                <el-input v-model="updateLinkData.name"></el-input>
              </el-form-item>
            </div>
            <div class="mb_20">
              <el-form-item label="联系人手机"
                            prop="phone">
                <el-input v-model="updateLinkData.phone"></el-input>
              </el-form-item>
            </div>
            <div class="mb_20">
              <el-form-item label="联系人邮箱"
                            prop="email">
                <el-input v-model="updateLinkData.email"></el-input>
              </el-form-item>
            </div>

          </div>
        </div>
        <div slot="footer"
             class="dialog_footer">
          <el-form-item>
            <el-button type="primary"
                       @click="uploadLinkData('updateLinkData')">确 定</el-button>
            <el-button @click="update_link_dialog = false">取 消</el-button>
          </el-form-item>
        </div>
      </el-dialog>
    </el-form>
  </div>
  <!-- <el-dialog
      title="我的联系人"
      :visible.sync="currentDialog"
      width="45%"
    >
      <div class="popup">
        <div class="popup_header flex mb_20">
          <el-button
            @click="update_link_dialog = true"
            class="mr_80"
            type="primary"
          >+添加联系人</el-button>
          <div class="popup_search flex mr_20">
            <div class="w_220 mr_20">
              <el-input v-model="linkParams.name" placeholder="请输入内容"></el-input>
            </div>
            <el-button
              @click="getLinkData()"
              type="primary"
            >搜索</el-button>
          </div>
          <el-button
            @click="resetLinkData"
            type="danger"
          >重置</el-button>
        </div>
        <div class="popup_main">
          <el-table
            :data="linkData"
            border
            style="width: 100%"
            class="mb_20"
          >
            <el-table-column
              prop="company"
              label="公司"
              width="180"
            ></el-table-column>
            <el-table-column
              prop="addr"
              label="地址"
              width="180"
            ></el-table-column>
            <el-table-column
              prop="email"
              label="邮箱"
            ></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="r">
                <el-button @click="contacterSelect(r.$index,r.row)" type="text">选择</el-button>
                <el-button @click="linkEditor(r.$index,r.row)" type="text">编辑</el-button>
                <el-button @click="linkDelete(r.$index,r.row)" class="color_red" type="text">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="flex justify_end">
          <el-pagination
            @current-change="linkPageChange"
            background
            layout="total, prev, pager, next"
            :total="linkTotal">
          </el-pagination>
        </div>
      </div>
      <el-form
        :model="updateLinkData"
        :rules="linkRules"
        ref="updateLinkData"
        label-width="140px"
      >
        <el-dialog
          :title="updateLinkData.company? '编辑联系人':'添加联系人'"
          :visible.sync="update_link_dialog"
          append-to-body
        >
          <div class="update_link_popup popup w_460">
            <div class="mb_20">
              <el-button
                @click="return_link"
                class="mr_80" type="primary"
              >返回</el-button>
            </div>
            <div class="popup_main">
              <div class="mb_20">
                <el-form-item label="公司名称" prop="company">
                  <el-input v-model="updateLinkData.company"></el-input>
                </el-form-item>
              </div>
              <div class="mb_20">
                <el-form-item label="公司地址" prop="addr">
                  <el-input v-model="updateLinkData.addr"></el-input>
                </el-form-item>
              </div>
              <div class="mb_20">
                <el-form-item label="国家" prop="country">
                  <el-select
                    v-model="updateLinkData.country"
                    placeholder="请选择国家"
                  >
                      <el-option
                        v-for="(link_item,lin_index) in countryData"
                        :key="lin_index"
                        :label="link_item.ch"
                        :value="link_item.ch">
                      </el-option>
                    </el-select>
                </el-form-item>
              </div>
              <div class="mb_20">
                <el-form-item label="联系人固话" prop="telephone">
                  <el-input v-model="updateLinkData.telephone"></el-input>
                </el-form-item>
              </div>
              <div class="mb_20">
                <el-form-item label="联系人姓名" prop="name">
                  <el-input v-model="updateLinkData.name"></el-input>
                </el-form-item>
              </div>
              <div class="mb_20">
                <el-form-item label="联系人手机" prop="phone">
                  <el-input v-model="updateLinkData.phone"></el-input>
                </el-form-item>
              </div>
              <div class="mb_20">
                <el-form-item label="联系人邮箱" prop="email">
                  <el-input v-model="updateLinkData.email"></el-input>
                </el-form-item>
              </div>

            </div>
          </div>
          <div slot="footer" class="dialog_footer">
            <el-form-item>
              <el-button
                type="primary"
                @click="uploadLinkData('updateLinkData')"
              >确 定</el-button>
              <el-button @click="update_link_dialog = false">取 消</el-button>
            </el-form-item>
          </div>
        </el-dialog>
      </el-form>
      <div slot="footer" class="dialog_footer">
        <el-button @click="contacter_dialog = false">关 闭</el-button>
      </div>
    </el-dialog> -->
</template>

<script>
  export default {
    props: {
      contacter_dialog: Boolean,
    },
    computed: {
      // currentDialog(){
      //   return this.contacter_dialog;
      // },
    },
    data() {
      return {
        currentDialog: false,
        linkData: [],
        linkParams: {
          cid: sessionStorage.customerId,
          pageNum: 1,
          pageSize: 10,
          name: '',
        },
        linkTotal: 0,
        isEditorLink: false,

        update_link_dialog: false,
        updateLinkData: {
          name: '',
          email: '',
          phone: '',
          telephone: '',
          country: '',
          company: '',
          addr: '',
        },

        countryData: [],

        linkRules: {
          'name': [
            { required: true, message: '请输入联系人姓名', trigger: 'blur' },
          ],
          'email': [
            { required: true, message: '请输入联系人邮箱', trigger: 'blur' },
          ],
          'phone': [
            { required: true, message: '请输入联系人手机', trigger: 'blur' },
          ],
          'telephone': [
            { required: true, message: '请输入联系人固定电话', trigger: 'blur' },
          ],
          'country': [
            { required: true, message: '请选择国家', trigger: 'blur' },
          ],
          'company': [
            { required: true, message: '请输入公司名称', trigger: 'blur' },
          ],
          'addr': [
            { required: true, message: '请输入公司地址', trigger: 'blur' },
          ],
        },
      };
    },
    created() {
      console.log(this.contacter_dialog);
      this.currentDialog = this.contacter_dialog;
      this.getLinkData();
      this.getAimCountryData();
    },
    methods: {
      close() {      console.log(999);
      },
      uploadLinkData(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let updateLinkData = this.updateLinkData;
            if (this.isEditorLink) {
              this.$axios
                .post('/admin/cusContacters/update', updateLinkData)
                .then(res => {
                  if (res.data.result) {
                    this.getLinkData();
                    this.update_link_dialog = false;
                  }
                });
              return;
            }
            updateLinkData.cid = sessionStorage.customerId;
            this.$axios
              .post('/admin/cusContacters/add', updateLinkData)
              .then(res => {

                if (res.data.result) {
                  this.getLinkData();
                  this.update_link_dialog = false;
                }
              });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
        return;
      },
      linkDelete(i, r) {
        this.$confirm('是否删除该联系人?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios
            .get('/admin/cusContacters/delete', {
              params: {
                id: r.id,
              },
            })
            .then(res => {
              if (res.data.result) {
                this.$message.success('删除成功!');
                this.linkData.splice(i, 1);
                this.linkTotal = this.linkTotal - 1;
              }
            });
        }).catch(() => { });
      },
      linkEditor(i, r) {
        this.updateLinkData = r;
        this.isEditorLink = true;
        this.update_link_dialog = true;
      },
      contacterSelect(i, r) {
        this.$emit('contacterSelect', r);
      },
      return_link() {
        this.update_link_dialog = false;
      },
      linkPageChange(i) {
        this.linkParams.pageNum = i;
        this.getLinkData();
      },
      getLinkDataSearch(){
        this.linkParams.pageNum = 1;
        this.getLinkData();
      },
      resetLinkData() {
        this.linkParams = {
          // cid: sessionStorage.userId,
          pageNum: 1,
          pageSize: 10,
          name: '',
        };
        this.getLinkData();
      },
      // 联系人列表
      getLinkData() {
        this.$axios
          .get("/admin/placeOrder/getCusContacters", {
            params: this.linkParams,
          })
          .then(res => {
            if (res.status == 200) {
              this.linkData = res.data.list.list;
              this.linkTotal = res.data.list.total;
            }
          });
      },
      // 获取目的国
      getAimCountryData() {
        this.$axios
          .get("/admin/placeOrder/getCountries")
          .then(res => {
            if (res.status == 200) {
              this.countryData = res.data.list;
            }
          });
      },
    },
  }
</script>

<style scoped>
  .mr_80 {
    margin-right: 80px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/theContacter.vue